import React, { useEffect, useState, useRef, useCallback } from "react";
import { message, notification } from 'antd';
import { Base64 } from "js-base64";
import dayjs from 'dayjs';
import { DescriptionText, FlexContainer, H1Text, H2Text, Spinner } from "../../design";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import {
    addChargeById,
    BASE_URLS,
    declinePaymentLinkByGid,
    getPaymentLinkById,
    getSecretValuesById,
    getCheckoutReconnection,
    getQrPaymentReconnection,
    paymentLinkSplitUp,
    calculatePaymentLinkSplitUp,
    getHealthCheck,
    getServerEncription,
    addPaymentLinkPageChargeById,
    getPaymentLinkChallanCharges,
    getPaymentLinkCardCharges,
    generateClientKeyPair,
    encryptData,
    getPayPalClientToken,
    getMrn,
    action,
    getWalletOrderInfo,
    confirmWalletOrderInfo,
    API2,
    cashfreeAction,
} from "../../api";
import { MESSAGES, PAYMENT_LINK_STATUSES, SWIREPAY_URL, TabNames, NETBANKING_LIST, QR_STATUSES, TANGEDCO_PG, SESSION_TIME, LPG_CUSTOMER, expireyText, ACQUIRER_TYPE_PAYPAL, ACQUIRER_TYPE_PAYPAL_BNY } from "../../appconstants";
import { AmountDivideByHundred } from "../../helper";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import SmallScreenFooter from "../../components/footer";
import currencyFormatter from "../../utils/currencyformatter";
import CardPayment from "../../components/cardpayment/CardPayment";
import Support from "../../components/support";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import getRedirectionUrl from "../../utils/getRedirectionUrl";
import UpiPayment from "../../components/upipayment/UpiPayment";
import AchPayment from "../../components/achPaymentWithPlaid";
import InstantPayment from "../../components/instantpayment/InstantPayment";
import GooglePay from "../../components/googlePay/GooglePay";
import BankPayment from "../../components/bankpayment/BankPayment";
import NetBanking from "../../components/netbanking/NetBanking";
import AlertModal from "../../components/modal/alert";
import WARNING_ICON from "../../assets/imgs/exclamation_warning.svg"
import SUCCESS_ICON from "../../assets/imgs/success.svg";
import EPaymentImg from "../../assets/imgs/e payments.svg";
import OMEGAITRlogo from "../../assets/imgs/OmegaITRlogo.png";
import ChallanPayment from "../../components/challanpayment/ChallanPayment";
import Apple from '../../routes/apple';
import PayPalCheckout from "../paypalCheckout";
import ZipAchPayment from '../../components/zipAchWithPlaid';
import RapidAchPayment from "../../components/rapidAchWithPlaid";
import XAchPayment from "../../components/xAchWithPlaid";
import { useDispatch, useSelector } from "react-redux";
import PaymentExpandableRows from "../../components/paymentExpandableRows";
import PaymentExpandableRowsV2 from "../../components/PaymentExpandableRowsV2";
import { setUpdateStatus } from "../../redux/customerDetailsInfo";
import PaymentError from "../../components/paymenterror";
import RecaptchaModal from "../../components/recaptcha";
import ApplePayButton from '../../routes/apple/PayPalApplePay';
import PayPalGooglePay from "../../components/payPalGooglePay";
import ZelleCheckout from "../zellCheckout";
import VerifyZellPaymentModal from "../zellCheckout/verifyZellPayment";
import ZellConfirmationModal from "../zellCheckout/zellConfirmation";
import { getCountryCodeAndNumber } from "../../utils/getCountryCodeAndNumber";
import SavedPaymentMethods from "../../components/SavedPaymentMethods";
import { setFormData, setIsWaitingForUpiApp, setUserReturnedFromUpiApp } from "../../redux/appConfigInfo";
import InstantAch from "../../components/InstantAch";
import SwiftAch from "../../components/SwiftAch";


type Props = {
    history: {
        push: Function,
    },
}

const PaymentLink = (props: Props) => {

    const { match: { params: { paymentLinkId } }, location: { pathname, search } } = props;
    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [payment, setPayment] = useState(null);
    const [errorMessage, setErrorMessage] = useState();
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [backButtonUrl, setBackButtonUrl] = useState(SWIREPAY_URL);
    const [userType, setUserType] = useState('');
    const [submitBtnText, setSubmitBtnText] = useState(null);
    const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
    const [paymentTypeOrder, setPaymentTypeOrder] = useState(null);
    const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${paymentLinkId}-tap-index`) || 0));
    const [tabName, setTabName] = useState('');
    const [banksList, setBanksList] = useState(null);
    const [isTest, setIsTest] = useState(null);
    const [bankTypes, supportedBankTypes] = useState([null]);
    const [bankImageUrl, setBankImageUrl] = useState(null);
    const [partnerImageUrl, setPartnerImageUrl] = useState(null);
    const [gpaySecretValues, setGpaySecretValues] = useState(null);
    const [gpayError, setGpayError] = useState(null);
    const [processStatus, setProcessStatus] = useState(false);
    const [applePayment, setApplePayment] = useState(false);
    const [swirepayUS, setSwirepayUS] = useState(false);
    const [googlePayUs, setGooglePayUs] = useState(false);
    const hostName = (window && window.location && window.location.host);
    const [ipAddress, setIpAddress] = useState('');
    const [net, setNet] = useState(null);
    const [serviceFeeEnabled, setServiceFeeEnabled] = useState(false);
    const [feeService, setFeeService] = useState(null);
    const [totalPayable, setTotalPayable] = useState(null);
    const [surcharge, setSurcharge] = useState(null);
    const [tax, setTax] = useState(null);
    const [tip, setTip] = useState(null);
    const [discount, setDiscount] = useState(null);
    const [subTotal, setSubTotal] = useState(null);
    const [serviceFeeVal, setServiceFeeVal] = useState(null);
    const [convenience, setConvenience] = useState(0);
    const [gst, setGst] = useState(0);
    const [totalAmount, setTotalAmount] = useState(null);
    const [isApplePay, setIsApplePay] = useState(false);
    const [updated, setUpdated] = useState(null);
    const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${paymentLinkId}`) || undefined);
    const [isShowErrorMessage, setShowErrorMessage] = useState(false);
    const updateCustomerRedux = useSelector((state) => state.customerDetailsInfo);
    const isWaitingForUpiApp = useSelector(state => state.appConfigInfo.isWaitingForUpiApp);
    const userReturnedFromUpiApp = useSelector(state => state.appConfigInfo.userReturnedFromUpiApp);
    const [recaptchaModalVisible, setRecaptchaModalVisible] = useState(false);
    const [savedPaymentDetails, setSavedPaymentDetails] = useState(null);
    const [recaptchaPaymentType, setRecaptchaPaymentType] = useState(null);
    const [paymentLinkUpiGlobalRecaptcha, setPaymentLinkUpiGlobalRecaptcha] = useState(null);
    const [paymentLinkInstantPaymentGlobalRecaptcha, setPaymentLinkInstantPaymentGlobalRecaptcha] = useState(null);
    const [manualPlaidPayment, setManualPlaidPayment] = useState(false);
    const [payPalClientAuth, setPayPalClientAuth] = useState('');
    const [paypalApplePayMessageModal, setPaypalApplePayMessageModal] = useState(false);
    const isPayPalApple = useRef(false);
    const isPayPalGoogle = useRef(false);
    const [zellRecaptcha, setZellRecaptcha] = useState(null);
    const [paypalApplePayRecaptcha, setPaypalApplePayRecaptcha] = useState(null);
    const [cardPointGooglePayToken, setCardPointGooglePayToken] = useState(null);
    const paypalPaymentData = useRef(null);
    const [payPalClientId, setPaypalClientId] = useState('');
    const commonRecaptchaToken = useRef(null);
    const [orderDatas, setOrderData] = useState();
    const paymentSessionGidRef = useRef(null);
    const redirectUrlRef = useRef(null);
    const upiAppPsClientSecretRef = useRef(null);
    const receiptNumberRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [zellPaymentSession, setZellPaymentSession] = useState('');
    const [open1, setOpen1] = useState(false);
    const [zellSecret, setZellSecret] = useState('');
    const upiIndentCheckStatus = useRef('');
    const inflightActionRef = useRef(null); // tracks the current action() call
    const updatedCardNum = useRef(null);
    const applySurchargeToggle = useRef(null);

    const dispatch = useDispatch();

    const accountGid = [
        'account-cdfe7eecff324778a88a2727177a1c8f'
    ];

    const getPayPalAccountInfo = async (id) => {
        try {
            const payPalInfo = await getPayPalClientToken(id);
            const value = Base64.decode(payPalInfo);
            const value_json = JSON.parse(value);
            setPaypalClientId(value_json?.clientId);
            setPayPalClientAuth(payPalInfo);
            return payPalInfo;
        } catch (e) {
            console.error(e);
        }
        return null;
    }

    const styles = {
        shape: "rect",
        layout: "vertical",
    };

    useEffect(() => {
        const acquirer = payment?.account?.acquirer;
        if (payment?.account?.gid && (acquirer === ACQUIRER_TYPE_PAYPAL || acquirer === ACQUIRER_TYPE_PAYPAL_BNY)) {
            getPayPalAccountInfo(payment?.account?.gid);
        }
    }, [payment]);

    const defaultAlertConfig = {
        showIcon: false, isOpen: false, hideBtn: true,
        cancel: null, header: null, body: null,
        submitBtnText: null, cancelBtnText: null, showCancelBtn: false,
        showSubmitBtn: false, submit: null, icon: null
    };

    const [alertConfig, setAlertConfig] = useState(defaultAlertConfig);

    const getData = async () => {
        const response = await fetch('https://api.ipify.org/?format=json');
        const data = await response.json();
        setIpAddress(data.ip);
    }

    useEffect(() => {
        if (updateCustomerRedux?.updateStatus && updateCustomerRedux?.customerDetails) {
            if (updateCustomerRedux?.customerDetails?.name && updateCustomerRedux?.customerDetails?.name !== '') {
                setPayment((prev) => ({ ...prev, name: updateCustomerRedux.customerDetails.name }));
            };
            if (updateCustomerRedux?.customerDetails?.email && updateCustomerRedux?.customerDetails?.email !== '') {
                setPayment((prev) => ({ ...prev, email: updateCustomerRedux.customerDetails.email }));
            };
            if (updateCustomerRedux?.customerDetails?.phoneNumber && updateCustomerRedux?.customerDetails?.phoneNumber !== 'undefined'
                && updateCustomerRedux?.customerDetails?.phoneNumber !== '+1'
            ) {
                setPayment((prev) => ({ ...prev, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber }));
            };
            dispatch(setUpdateStatus(false));
        };
    }, [updateCustomerRedux])

    useEffect(() => {
        getData();
    }, []);

    useState(() => {
        if (window.ApplePaySession) {
            setIsApplePay(true);
        }
    }, []);

    useEffect(() => {
        if (errorMessage) {
            setShowErrorMessage(true);
        } else {
            setShowErrorMessage(false);
        }
    }, [errorMessage]);

    useEffect(() => {
        if (search) {
            getPaymentLinkDataWithSearchValue();
        } else {
            getPaymentLinkDataWithoutSearchValue();
        }
    }, [paymentLinkId, search]);

    useEffect(() => {
        setApplePayment(payment && payment.account && payment.account.supportedPaymentTypes.includes('APPLE_PAY_US'));
        setSwirepayUS(payment && payment.account && payment.account.supportedPaymentTypes.includes('SWIREPAY_US'));
        setGooglePayUs(payment && payment.account && payment.account.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
        const buttonPrefixTxt = payment?.captureMethod === 'MANUAL' ? 'Authorize' : 'PAY';
        if (payment && payment.currency && payment.amount && payment.tip) {
            setSubmitBtnText(`${buttonPrefixTxt} ${currencyFormatter(AmountDivideByHundred(payment.amount + payment.tip + (payment?.serviceFee || 0)), payment.currency.name)}`)
        } else if (payment && payment.currency && payment.amount) {
            setSubmitBtnText(`${buttonPrefixTxt} ${currencyFormatter(AmountDivideByHundred(payment.amount + (payment?.serviceFee || 0)), payment.currency.name)}`)
        }
        if (payment && payment.account && payment.account.gid) {
            setApplePayment(payment && payment.account && payment.account.supportedPaymentTypes.includes('APPLE_PAY_US'));
            setSwirepayUS(payment && payment.account && payment.account.supportedPaymentTypes.includes('SWIREPAY_US'));
            setGooglePayUs(payment && payment.account && payment.account.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
            if (TANGEDCO_PG === payment.account.gid) {
                if (payment.account.paymentTypeOrder) {
                    setPaymentTypeOrder([{ category: 'CARD' }]);
                } else setSupportedPaymentTypes(['CARD']);
            } else if (TANGEDCO_PG !== payment.account.gid) {
                if (payment.account.paymentTypeOrder) {
                    const paymentMethod = payment && payment.paymentMethodType;
                    const paymentOrders = payment && payment.account && payment.account.paymentTypeOrder;
                    const filterPaymentOrder = paymentOrders.filter((order) => paymentMethod.includes(order.category));
                    let newfilterPaymentOrder;
                    if (payment.account && paymentMethod.includes('WALLET')) {
                        setPaymentTypeOrder(filterPaymentOrder);
                    } else {
                        newfilterPaymentOrder = filterPaymentOrder.filter(info => info.category !== 'WALLET');
                        setPaymentTypeOrder(newfilterPaymentOrder);
                    }
                } else {
                    setSupportedPaymentTypes(payment && payment.paymentMethodType);
                }
            }
        }
    }, [payment]);

    useEffect(() => {
        setErrorMessage(null);
    }, [selectedTab]);

    const getPaymentLinkDataWithSearchValue = async () => {
        const params = new URLSearchParams(search);
        if (!(params.get('ps') || params.get('mp')) || !params.get('secret')) {
            props.history.push(`${pathname}/error`);
            return;
        }
        setShowSpinner(true);
        try {
            const value = await getPaymentLinkById(paymentLinkId, search);
            if (value) {
                const { redirectUri, status, receiptNumber } = value;
                setUserType(value.account && value.account.mdr);
                setPayment(value);
                dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
                  value: {
                    phoneNumber: getCountryCodeAndNumber(value?.phoneNumber)?.phoneNumber,
                    countryCode: getCountryCodeAndNumber(value?.phoneNumber)?.countryCode || '+1',
                    name: value?.name,
                    email: value?.email,
                    disablePhone: !!value?.phoneNumber,
                    disableEmail: !!value?.email,
                    disableName: !!value?.name,
                  } 
                }));
                const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (PAYMENT_LINK_STATUSES.ACTIVE !== status) {
                    const uri = getRedirectionUrl(hostName);
                    if (uri && !redirectUri && receiptNumber) {
                        window.location = `${uri}receipts/${receiptNumber}`;
                    }
                    if (!redirectUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(function () {
                        if (redirectUri) {
                            window.location = `${redirectUri}?sp-payment-link=${paymentLinkId}`;
                        }
                    }, timeOut);
                }
            }
        } catch (reason) {
            try {
                const value = await getPaymentLinkById(paymentLinkId, null);
                if (value) {
                    setPayment(value);
                    dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
                      value: {
                        phoneNumber: getCountryCodeAndNumber(value?.phoneNumber)?.phoneNumber,
                        countryCode: getCountryCodeAndNumber(value?.phoneNumber)?.countryCode || '+1',
                        name: value?.name,
                        email: value?.email,
                        disablePhone: !!value?.phoneNumber,
                        disableEmail: !!value?.email,
                        disableName: !!value?.name,
                      } 
                    }));
                    if (value.account && value.account.portal) {
                        const portal = value.account.portal.test;
                        setIsTest(portal);
                        setBankImageUrl(value.account && value.account.bankImageUrl);
                        setPartnerImageUrl(value.account && value.account.partnerImageUrl);
                        supportedBankTypes(value.account.supportedPaymentTypes);
                        if (portal) {
                            const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === true));
                            setBanksList(supportedBanks);
                        } else {
                            const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === false));
                            setBanksList(supportedBanks);
                        }
                    }
                }
            } catch (e) {
                props.history.push(`${pathname}/error`);
            }
            error(reason);
        } finally {
            setShowSpinner(false);
        }
    };

    const error = useCallback(reason => {
        if (!reason?.data && !reason?.response?.data) return;
        if (reason?.response?.data?.entity?.receiptNumber) return;
        setErrorMessage(null);
        let errorResponse = reason;
        if (reason?.response) {
          errorResponse = reason?.response;
        }
        const { data: { message, messageCode }, status } = errorResponse;
        if (MESSAGES.PAYMENT_LINK.EXPIRED === message) {
            props.history.push(`${pathname}/expired`)
        } else {
            if (messageCode === 5102) {
                props.history.push(`${pathname}/error`);
                return;
            }
            setErrorMessage(message);
            if (status === 500) {
                setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
            }
            setAlertConfig({ showIcon: false, isOpen: false, hideBtn: true, cancel: null, header: null, body: null, submitBtnText: null, cancelBtnText: null, showCancelBtn: false, showSubmitBtn: false, submit: null, icon: null });
            setTransactionModalOpen(false);
            const errorEl = document.getElementById("error");
            if (null !== errorEl) { errorEl.scrollIntoView(); }
        }
    }, [pathname, props.history]);

    const getGooglePayMerchantValues = async (accountGid, isTest) => {
        try {
            const values = await getSecretValuesById(accountGid, isTest);
            setGpaySecretValues(values);
        } catch (error) {
            setGpayError('Missing merchant details. Please contact support');
        }
    };

    const getSplitUp = async (id, payload, info) => {
        try {
            const value = await paymentLinkSplitUp(id, payload);
            setNet(value.amount || 0);
            setFeeService(value.serviceFee || 0);
            setTotalPayable(value.totalPayable || 0);
            setSurcharge(value.surcharge || 0);
            setTax(value.tax || 0);
            setTip(value.tip || 0);
            setDiscount(value.discountedAmount || 0);
            setSubTotal(value.subTotal || 0);
            setServiceFeeVal(value.serviceFee || 0);
            const buttonPrefixTxt = payment?.captureMethod === 'MANUAL' ? 'Authorize' : 'PAY';
            setSubmitBtnText(`${buttonPrefixTxt} ${currencyFormatter(AmountDivideByHundred(value.totalPayable), info.currency.name)}`)
        } catch (reason) {
            error(reason);
        }
    }

    const getCurrentTab = (tabName) => {
        if (tabName === 'CARD' && !updatedCardNum.current) return;
        const paymentInfo = {
            type: tabName,
        };
        if (tabName === 'CARD') {
            paymentInfo.cardNum = updatedCardNum.current;
        }
        calculateSplitUp(payment?.gid, paymentInfo, payment);
    };

    const updateSurcharge = (val, selectedDirectoryGid = null) => {
        applySurchargeToggle.current = val;
        const currentTab = localStorage.getItem(`${paymentLinkId}-tab-name`);
        if (currentTab === 'CARD' && !updatedCardNum.current) return;
        const paymentInfo = {
            type: selectedDirectoryGid ? 'DIRECTORY' : currentTab,
            cardNum: currentTab === 'CARD' ?  updatedCardNum.current : null,
            directoryGid: selectedDirectoryGid,
            applySurcharge: val,
        };
        calculateSplitUp(payment?.gid, paymentInfo, payment);
    };

    const getCardNum = (cardNum) => {
        if (!cardNum) return;
        updatedCardNum.current = cardNum;
        const paymentInfo = {
            type: 'CARD',
            cardNum,
            applySurcharge: !!applySurchargeToggle.current,
        };
        calculateSplitUp(payment?.gid, paymentInfo, payment);
    };

    const calculateSplitUp = async (id, paymentInfo, info) => {
        try {
            let payload = {};
            let surchargeApplicability = false;
            if (payment?.surchargeEnabled && payment?.account?.surchargeType === 'FORCED') {
                surchargeApplicability = true;
            }
            if (payment?.surchargeEnabled && payment?.account?.surchargeType === 'OPTIONAL') {
                surchargeApplicability = typeof paymentInfo?.applySurcharge === 'boolean' ? paymentInfo?.applySurcharge : false;
            }
            switch (paymentInfo?.type) {
                case 'CARD':
                    payload = {
                        "paymentType": "CARD",
                        "cardNumber": paymentInfo?.cardNum || null,
                        "surchargeApplicable": surchargeApplicability,
                        "directoryPaymentMethodGid": paymentInfo?.directoryGid || null,
                    };
                    break;
                default:
                    payload = {
                        "paymentType": paymentInfo?.type,
                        "surchargeApplicable": surchargeApplicability,
                        "directoryPaymentMethodGid": paymentInfo?.directoryGid || null,
                    };
            }
            const value = await calculatePaymentLinkSplitUp(id, payload);
            setNet(value.amount || 0);
            setFeeService(value.serviceFee || 0);
            setTotalPayable(value.totalPayable || 0);
            setSurcharge(value.surcharge || 0);
            setTax(value.tax || 0);
            setTip(value.tip || 0);
            setDiscount(value.discountedAmount || 0);
            setSubTotal(value.subTotal || 0);
            setServiceFeeVal(value.serviceFee || 0);
            const buttonPrefixTxt = payment?.captureMethod === 'MANUAL' ? 'Authorize' : 'PAY';
            setSubmitBtnText(`${buttonPrefixTxt} ${currencyFormatter(AmountDivideByHundred(value.totalPayable), info.currency.name)}`);
        } catch (reason) {
            error(reason);
        }
    };

    useEffect(() => {
        if (payment && paymentLinkId && payment?.status === PAYMENT_LINK_STATUSES.ACTIVE) {
            getSplitUp(paymentLinkId, payment?.amount, payment);
        }
    }, [payment, paymentLinkId]);

    const getPaymentCharges = async (cardNumber, payments) => {
        setPayment(payments);
        dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
          value: {
            phoneNumber: getCountryCodeAndNumber(payments?.phoneNumber)?.phoneNumber,
            countryCode: getCountryCodeAndNumber(payments?.phoneNumber)?.countryCode || '+1',
            name: payments?.name,
            email: payments?.email,
            disablePhone: !!payments?.phoneNumber,
            disableEmail: !!payments?.email,
            disableName: !!payments?.name,
          } 
        }));
        try {
            let value = null;
            if (null != cardNumber) {
                value = await getPaymentLinkCardCharges(paymentLinkId, cardNumber);
            } else {
                value = await getPaymentLinkChallanCharges(paymentLinkId);
            }
            if (value) {
                setConvenience(currencyFormatter(AmountDivideByHundred(value.feeAmount)));
                setGst(currencyFormatter(AmountDivideByHundred(value.taxAmount)));
                setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(payments.amount + value.feeAmount + value.taxAmount), payments.currency.name)}`)
                setTotalAmount(currencyFormatter(AmountDivideByHundred(payments.amount + value.feeAmount + value.taxAmount), payments.currency.name));
            }
        } catch (e) {
            setConvenience(0);
            setGst(0);
            setTotalAmount(currencyFormatter(AmountDivideByHundred(payments.amount), payments.currency.name));
        } finally {
            setShowSpinner(false)
        }
    }

    const getPaymentLinkDataWithoutSearchValue = async () => {
        setShowSpinner(true);
        try {
            const value = await getPaymentLinkById(paymentLinkId, null);
            if (value) {
                const { status, redirectUri } = value;
                if (PAYMENT_LINK_STATUSES.ACTIVE !== status) {
                    props.history.push(`${pathname}/expired`);
                    return;
                }
                // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
                //     const val = await getHealthCheck();
                //     if (val && val.status !== 'ACTIVE') {
                //         setUpiDownTime(true);
                //         notification.open({
                //             message: '',
                //             description: <img src={UPIIMAGE} alt="" />,
                //           });
                //     }
                // }
                setPayment(value);
                dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
                  value: {
                    phoneNumber: getCountryCodeAndNumber(value?.phoneNumber)?.phoneNumber,
                    countryCode: getCountryCodeAndNumber(value?.phoneNumber)?.countryCode || '+1',
                    name: value?.name,
                    email: value?.email,
                    disablePhone: !!value?.phoneNumber,
                    disableEmail: !!value?.email,
                    disableName: !!value?.name,
                  } 
                }));
                if ((value && value.serviceFeeEnabled) === true) {
                    setServiceFeeEnabled(value && value.serviceFeeEnabled);
                    getSplitUp(paymentLinkId, value.amount, value);
                }
                if (value.account && value.account.portal) {
                    const portal = value.account.portal.test;
                    setIsTest(portal);
                    setBankImageUrl(value.account && value.account.bankImageUrl);
                    setPartnerImageUrl(value.account && value.account.partnerImageUrl);
                    supportedBankTypes(value.account.supportedPaymentTypes);
                    if (portal) {
                        const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === true));
                        setBanksList(supportedBanks);
                    } else {
                        const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === false));
                        setBanksList(supportedBanks);
                    }
                }
                if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('GOOGLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && !swirepayUS && value.account.supportedPaymentTypes).includes('WALLET')) {
                    getGooglePayMerchantValues(value && value.account && value.account.gid, value?.account?.portal?.test);
                }
                // if ((value && value.account && value.account.supportedPaymentTypes).includes('APPLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes).includes('WALLET')) {
                //     getGooglePayMerchantValues(value && value.account && value.account.gid);
                // }
                setBackButtonUrl(redirectUri || SWIREPAY_URL)
            }
        } catch (e) {
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    const getCustomerGidFromPayment = () => {
        return payment && payment.customer && payment.customer.gid;
    };

    const chargeByUpi = async (data) => {
        const { customer, paymentMethod, notify } = data;
        const userAgent = {
          acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
          ip: ipAddress,
          language: window.navigator.language,
          colorDepth: window.screen.colorDepth,
          screenHeight: window.screen.height,
          screenWidth: window.screen.width,
          timeZone: new Date().getTimezoneOffset(),
          browserUserAgent: window.navigator.userAgent
        };
        paymentMethod.userAgent = userAgent;
        await chargeById({ customer, paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByAch = async (data) => {
        const { customer, paymentMethod, notify } = data;
        await chargeById({ customer, paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByZipAch = async (data) => {
        const { customer, paymentMethod, notify } = data;
        await chargeById({ customer, paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByCard = async (data) => {
        const { customer, paymentMethod, notify } = data;
        const userAgent = {
            acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
            ip: ipAddress,
            language: window.navigator.language,
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
            timeZone: new Date().getTimezoneOffset(),
            browserUserAgent: window.navigator.userAgent
        };
        paymentMethod.userAgent = userAgent;
        await chargeById({ customer, paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByBank = async (data) => {
        const { fundingSourceId } = data;
        const paymentMethod = {
            type: "ACH",
            bank: {
                referenceId: fundingSourceId,
            },
        };
        await chargeById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByNetBanking = async (data) => {
        const { gid, notify } = data;
        const paymentMethod = {
            type: "NET_BANKING",
            netbanking: {
                swirepayBankGid: gid,
            },
        };
        await chargeById({ paymentMethod: paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByInstantPay = async (data) => {
        const { walletAlias, notify } = data;
        const paymentMethod = {
            type: "INSTANT_PAYMENT",
            instantPayment: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        await chargeById({ paymentMethod: paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeBySwirepayUS = async (data) => {
        const { walletAlias, notify } = data;
        const paymentMethod = {
            type: "WALLET",
            subType: "SWIREPAY_US",
            swirepayUS: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        await chargeById({ paymentMethod: paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByIdSuccessActions = async (value) => {
        const { nextActionUrl, redirectUri, receiptNumber, paymentStatus } = value;
        if (paymentStatus && paymentStatus === 'PROCESSING') {
            setProcessStatus(true);
        }
        if (paymentStatus && paymentStatus === 'REQUIRE_CONFIRMATION') {
            setManualPlaidPayment(true);
        }
        if (nextActionUrl) {
            window.location = nextActionUrl;
            return;
        }
        const timeOut = value?.paymentStatus === 'REQUIRE_CONFIRMATION' ? SESSION_TIME.MANUAL_PLAID
            : redirectUri ? SESSION_TIME.REDIRECT_URL
                : SESSION_TIME.NO_REDIRECT_URL;
        setTransactionModalOpen(false);
        if (!redirectUri) {
            setTransactionSuccessModalOpen(true);
        }
        setTimeout(function () {
            const uri = getRedirectionUrl(hostName);
            const redirectUrl = redirectUri ? redirectUri : '';
            const urlPath = redirectUrl.includes("?");
            if (urlPath) {
                window.location = `${redirectUrl}&sp-payment-link=${paymentLinkId}`;
            } else if (!urlPath && redirectUrl) {
                window.location = `${redirectUrl}?sp-payment-link=${paymentLinkId}`;
            } else if (uri && !redirectUrl) {
                if (receiptNumber) {
                    window.location = `${uri}receipts/${receiptNumber}`;
                } else window.location = SWIREPAY_URL;
            }
            sessionStorage.removeItem("stripeRes");
            sessionStorage.removeItem(`plaidPublicToken-${paymentLinkId}`);
        }, timeOut);
        if (paymentLinkId) { localStorage.removeItem(`${paymentLinkId}-tap-index`) }
    };

    const chargeByUpiIndent = async (data) => {
        const payaloadData = {
            paymentMethod: data?.paymentMethod,
            customerGid: getCustomerGidFromPayment(payment),
        }
        try {
          const values = await getServerEncription(commonRecaptchaToken.current || null);
          commonRecaptchaToken.current = null;
          if (values?.public_key) {
            const keys = generateClientKeyPair();
            if (keys?.privateKey) {
              const encriptedData = encryptData(JSON.stringify(payaloadData), values.public_key, keys.privateKey, values.key_id);
              const payload = {
                publicKey: keys?.publicKey,
                keyId: encriptedData?.keyId,
                iv: encriptedData?.iv,
                data: encriptedData?.encryptedData,
              }
              if (encriptedData?.keyId) {
                const value = await addChargeById(paymentLinkId, payload);
                if (value) {
                  const { nextActionUrl, redirectUri, receiptNumber } = value;
                  paymentSessionGidRef.current = value?.paymentSessionGid;
                  upiAppPsClientSecretRef.current = value?.psClientSecret;
                  redirectUrlRef.current = redirectUri;
                  receiptNumberRef.current = receiptNumber;
                  return (nextActionUrl || null);
                }
              }
            }
          }
          return null;
        } catch (reason) {
          if (reason?.status === 429) {
            // reset the states
            paymentSessionGidRef.current = null; 
            upiAppPsClientSecretRef.current = null;
            dispatch(setIsWaitingForUpiApp(null));
            dispatch(setUserReturnedFromUpiApp(null));
            upiIndentCheckStatus.current = '';
            commonRecaptchaToken.current = null;
            // handle recaptcha
            setRecaptchaPaymentType('upi_indent');
            setRecaptchaModalVisible(true);
            setTransactionModalOpen(false);
            return;
          }
          
          error(reason);
        }
      };
    
      const handleRedirect = () => {
        const uri = getRedirectionUrl(hostName);
        const redirectUrl = redirectUrlRef?.current ? redirectUrlRef?.current : '';
        const urlPath = redirectUrl.includes("?");
        if (urlPath) {
            window.location = `${redirectUrl}&sp-payment-link=${paymentLinkId}`;
        } else if (!urlPath && redirectUrl) {
            window.location = `${redirectUrl}?sp-payment-link=${paymentLinkId}`;
        } else if (uri && !redirectUrl) {
            if (receiptNumberRef?.current) {
                window.location = `${uri}receipts/${receiptNumberRef?.current}`;
            } else window.location = SWIREPAY_URL;
        }
        sessionStorage.removeItem("stripeRes");
        sessionStorage.removeItem(`plaidPublicToken-${paymentLinkId}`);
        if (paymentLinkId) { localStorage.removeItem(`${paymentLinkId}-tap-index`) }
      };

    const checkLinkStatus = async () => {
      // Check payment link status during polling
      try {
        const paymentLinkResponse = await getPaymentLinkById(paymentLinkId, null);
        if (paymentLinkResponse && paymentLinkResponse.status !== 'ACTIVE') {
          // Show expiry message to user using the existing AlertModal
          setAlertConfig({
            showIcon: true, 
            isOpen: true, 
            hideBtn: true,
            header: "Payment Link Expired", 
            body: "This payment link is no longer active. You will be redirected shortly.",
            showSubmitBtn: false, 
            showCancelBtn: false,
            icon: WARNING_ICON
          });
          // Payment link is not active (expired), redirect immediately
          setTimeout(() => handleRedirect(), 5000);
          return;
        }
      } catch (err) {
        console.error('Could not check payment link status during polling:', err);
      }
    };
    
    const onReturnFromUpiApp = async () => {
        setTransactionModalOpen(true);

        // wait for any in-flight long poll request to settle first
        // prevent double calls
        if (inflightActionRef.current) {
            const response = await inflightActionRef.current.catch(() => {}); // ignore errors, just wait
            upiIndentCheckStatus.current = response?.data?.entity?.status;
        }

        try {
          const paymentSessionId = paymentSessionGidRef?.current;
          const clientSecret = upiAppPsClientSecretRef?.current;
    
          if (!paymentSessionId || !clientSecret) {
            handleRedirect();
            return;
          }

          // poll to check if the transaction has processed
          let entity;
          let response;
          let attempts = 0;
          const MAX_ATTEMPTS = 15; // poll every 1s for upto 15 seconds
          const POLLING_INTERVAL = 1000;
          while (attempts < MAX_ATTEMPTS && (upiIndentCheckStatus.current === 'REQUIRE_ACTION' || !upiIndentCheckStatus.current)) {
            if (payment?.account?.acquirer === 'CASHFREE') {
              response = await cashfreeAction(paymentSessionId, clientSecret);
              entity = response?.data?.entity;
            } else {
              response = await action(paymentSessionId, clientSecret);
              entity = response?.data?.entity;
            }
            if (entity?.status === 'REQUIRE_ACTION') {
              await new Promise(resolve => setTimeout(resolve, POLLING_INTERVAL));
              attempts++;
            } else {
              break;
            }
          }
          if (entity?.status === 'SUCCEEDED' || upiIndentCheckStatus.current === 'SUCCEEDED') {
            setTransactionSuccessModalOpen(true);
    
            const timeout = redirectUrlRef?.current
              ? SESSION_TIME.REDIRECT_URL
              : SESSION_TIME.NO_REDIRECT_URL;
    
            setTimeout(() => {
              handleRedirect();
            }, timeout);
    
            return;
          } else if (entity?.status === 'REQUIRE_ACTION') {
            error({ data: { message: 'UPI payment could not be verified at the moment.' }, });
            checkLinkStatus();
          } else {
            error(response?.data?.message ? response : { data: { message: 'UPI Payment Failed' }, });
            checkLinkStatus();
          }
    
          // Failed or other status
          // handleRedirect();
    
        } catch (e) {
          console.error("UPI return error:", e);
          error(e);
          // handleRedirect();
        } finally {
          setTransactionModalOpen(false);
          // reset the states
          paymentSessionGidRef.current = null; 
          upiAppPsClientSecretRef.current = null;
          dispatch(setIsWaitingForUpiApp(null));
          dispatch(setUserReturnedFromUpiApp(null));
          upiIndentCheckStatus.current = '';
        }
      };

    useEffect(() => {
      if (!isWaitingForUpiApp || userReturnedFromUpiApp) return;

      let cancelled = false;
      const checkUpiStatus = async () => {
        setTransactionModalOpen(true);
        try {
          const paymentSessionId = paymentSessionGidRef?.current;
          const clientSecret = upiAppPsClientSecretRef?.current;
          if (!paymentSessionId || !clientSecret) {
            error({ data: { message: 'Could not check UPI payment.', }, });
            return;
          }
          // poll to check if the transaction has processed
          let entity;
          let response;
          let attempts = 0;
          const MAX_ATTEMPTS = 30; // poll every 10s for upto 5 mins
          const POLLING_INTERVAL = 10000;
          while (attempts < MAX_ATTEMPTS) {
            if (cancelled) {
              return;
            }
            const promise = payment?.account?.acquirer === 'CASHFREE'
                ? cashfreeAction(paymentSessionId, clientSecret)
                : action(paymentSessionId, clientSecret);
            inflightActionRef.current = promise; // register api call; used to prevent double calls when switching to short polling
            response = await promise;
            inflightActionRef.current = null; // clear when done
            entity = response?.data?.entity;
            upiIndentCheckStatus.current = entity?.status;
            if (entity?.status === 'REQUIRE_ACTION') {
              await new Promise(resolve => setTimeout(resolve, POLLING_INTERVAL));
              attempts++;
            } else {
              break;
            }
          }
          if (cancelled) return;
          if (entity?.status === 'REQUIRE_ACTION') {
            error({ data: { message: 'UPI payment could not be verified at the moment.' }, });
            checkLinkStatus();
            setTransactionModalOpen(false);
            paymentSessionGidRef.current = null; 
            upiAppPsClientSecretRef.current = null;
            dispatch(setIsWaitingForUpiApp(null));
            dispatch(setUserReturnedFromUpiApp(null));
            upiIndentCheckStatus.current = '';
          } else if (entity?.status !== 'SUCCEEDED') {
            error(response?.data?.message ? response : { data: { message: 'UPI Payment Failed' }, });
            checkLinkStatus();
            setTransactionModalOpen(false);
            paymentSessionGidRef.current = null; 
            upiAppPsClientSecretRef.current = null;
            dispatch(setIsWaitingForUpiApp(null));
            dispatch(setUserReturnedFromUpiApp(null));
            upiIndentCheckStatus.current = '';
          }
        } catch (e) {
          if (cancelled) return;
          console.error("UPI return error:", e);
          error(e);
        }
      };

      checkUpiStatus();
      return () => { cancelled = true; };
    }, [
      isWaitingForUpiApp,
      userReturnedFromUpiApp,
      error,
      payment?.account?.acquirer,
    ]);

    const chargeById = async (data, recaptchaToken = null) => {
        setTransactionModalOpen(true);
        try {
            const values = await getServerEncription(recaptchaToken);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    }
                    if (encriptedData?.keyId) {
                        const value = await addChargeById(paymentLinkId, payload);
                        if (value) {
                            if (!isPayPalApple.current
                                && !isPayPalGoogle.current
                            ) {
                                await chargeByIdSuccessActions(value);
                            }
                            return value;
                        }
                    }
                }
            }

        } catch (reason) {
            if (reason?.status === 429) {
                setSavedPaymentDetails(data);
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                return;
            }
            error(reason);
            return reason;
        }
    };

    const onGlobalCaptchaVerified = async (token) => {
        setRecaptchaModalVisible(false);
        switch (recaptchaPaymentType) {
            case TabNames.CHALLAN:
                await generateChallan(savedPaymentDetails, token);
                break;
            case TabNames.UPI:
                setPaymentLinkUpiGlobalRecaptcha(token);
                break;
            case 'paypalApplePay':
                setPaypalApplePayRecaptcha(token);
                setPaypalApplePayMessageModal(true);
                break;
            case 'paypalGooglePay':
                if (paypalPaymentData.current) {
                    chargeByPaypalGooglePay(paypalPaymentData.current, token);
                }
                break;
            case 'cardPointGooglePay':
                setCardPointGooglePayToken(token);
                break;
            case TabNames.INSTANT_PAYMENT:
                setPaymentLinkInstantPaymentGlobalRecaptcha(token);
                break;
            case 'payPalButton':
                commonRecaptchaToken.current = token;
                break;
            case 'upi_indent':
                commonRecaptchaToken.current = token;
                break;
            case 'zelle':
                chargeByZellPay(savedPaymentDetails, token);
                break;
            default:
                await chargeById(savedPaymentDetails, token);
        }
        setRecaptchaPaymentType(null);
    }

    const cancelAlertOpen = () => {
        setAlertConfig({
            showIcon: true, isOpen: true, hideBtn: false,
            cancel: resetAlertConfig, header: "Are you sure!", body: "You will not be able to recover this payment link",
            submitBtnText: "Yes, decline it!", cancelBtnText: "Cancel", showCancelBtn: true,
            showSubmitBtn: true, submit: declinePaymentLink, icon: WARNING_ICON
        });
    };

    const resetAlertConfig = () => {
        setAlertConfig(defaultAlertConfig)
    };

    const chargeByIdFailActions = async () => {
        setTransactionModalOpen(false);
    };

    const getPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
            const value = await getCheckoutReconnection(paymentSession, psClientSecret);
            if (value) {
                const { status, receiptNumber } = value;
                const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (status === QR_STATUSES.SUCCEEDED) {
                    if (!redirectionUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(function () {
                        const uri = getRedirectionUrl(hostName);
                        const redirectUrl = redirectionUri ? redirectionUri : '';
                        const urlPath = redirectUrl.includes("?");
                        if (urlPath) {
                            window.location = `${redirectUrl}&sp-payment-link=${paymentLinkId}`;
                        } else if (redirectUrl && !urlPath) {
                            window.location = `${redirectUrl}?sp-payment-link=${paymentLinkId}`;
                        } else if (uri) {
                            window.location = `${uri}receipts/${receiptNumber}`;
                        }
                    }, timeOut);
                    if (paymentLinkId) { localStorage.removeItem(`${paymentLinkId}-tap-index`) }
                }
            }
        } catch (reason) {
            error(reason);
        }
    };

    const getQrPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
            const value = await getQrPaymentReconnection(paymentSession, psClientSecret);
            if (value) {
                const { status, receiptNumber } = value;
                const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (status === QR_STATUSES.SUCCEEDED) {
                    if (!redirectionUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(function () {
                        const uri = getRedirectionUrl(hostName);
                        const redirectUrl = redirectionUri ? redirectionUri : '';
                        const urlPath = redirectUrl.includes("?");
                        if (urlPath) {
                            window.location = `${redirectUrl}&sp-payment-link=${paymentLinkId}`;
                        } else if (redirectUrl && !urlPath) {
                            window.location = `${redirectUrl}?sp-payment-link=${paymentLinkId}`;
                        } else if (uri) {
                            window.location = `${uri}receipts/${receiptNumber}`;
                        }
                    }, timeOut);
                    if (paymentLinkId) { localStorage.removeItem(`${paymentLinkId}-tap-index`) }
                }
            }
        } catch (reason) {
            error(reason);
        }
    };

    const addCheckoutPageById = async (data, recaptchaToken = null) => {
        setTransactionModalOpen(true);

        try {
            const values = await getServerEncription(recaptchaToken);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    };
                    if (encriptedData?.keyId) {
                        const value = await addPaymentLinkPageChargeById(paymentLinkId, payload);
                        console.log(value, "prDEES");
                        if (value) {
                            const { nextActionUrl, redirectUri } = value;

                            const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                            if (nextActionUrl) {
                                window.location = nextActionUrl;
                                return;
                            }
                            setTransactionModalOpen(false);
                            if (!redirectUri) {
                                setTransactionSuccessModalOpen(true);
                            }
                            setTimeout(function () {
                                const redirectUrl = redirectUri ? redirectUri : SWIREPAY_URL;
                                const urlPath = redirectUrl.includes("?");
                                if (urlPath) {
                                    window.location = `${redirectUrl}&sp-checkout-page=${paymentLinkId}`;
                                } else if (!urlPath) {
                                    window.location = `${redirectUrl}?sp-checkout-page=${paymentLinkId}`;
                                }
                                sessionStorage.removeItem("stripeRes");
                            }, timeOut);
                            if (paymentLinkId) { localStorage.removeItem(`${paymentLinkId}-tap-index`) }
                        }
                    }
                }
            }
        } catch (reason) {
            if (reason?.status === 429) {
                setSavedPaymentDetails(data);
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                setRecaptchaPaymentType(TabNames.CHALLAN);
                return;
            }
            setTimeout(function () {
                window.location = payment && payment.redirectUri;
            }, 1000);
            // error(reason);
        }
    };
    const generateChallan = async (data, token = null) => {

        await addCheckoutPageById(data, token);
    };

    const declinePaymentLink = () => {
        setAlertConfig({
            ...defaultAlertConfig,
            showIcon: true, isOpen: true, hideBtn: true,
            header: `Please Wait!. Your payment link decline is being processed`, body: "You will be redirected when the decline is successful.",
        });
        if (payment && payment.gid) {
            declinePaymentLinkByGid(payment.gid).then(value => {
                if (value) {
                    const { redirectUri } = value;
                    const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                    setAlertConfig({
                        ...defaultAlertConfig,
                        showIcon: true, isOpen: true, hideBtn: true,
                        header: "PaymentLink Decline Completed", body: "You will be redirected automatically.",
                        icon: SUCCESS_ICON
                    });
                    setTimeout(function () {
                        const redirectUrl = redirectUri || SWIREPAY_URL;
                        const urlPath = redirectUrl.includes("?");
                        const decline = "decline=true";
                        if (urlPath) {
                            window.location = `${redirectUrl}&${decline}`;
                        } else if (redirectUrl && !urlPath) {
                            window.location = `${redirectUrl}?${decline}`;
                        }
                    }, timeOut);
                }
            }).catch(reason => error(reason));
        }
    };

    const chargeByPaypalGooglePay = async (data, localRecaptchaToken = null) => {
        try {
            paypalPaymentData.current = data;
            setTransactionModalOpen(true);
            setRecaptchaPaymentType('paypalGooglePay');
            const value = await getPayPalAccountInfo(payment?.account?.gid);
            if (value) {
                isPayPalGoogle.current = true;
                const paymentMethod = {
                    type: "WALLET",
                    subType: "GOOGLE_PAY_US",
                    googlePayUS: {
                        apiVersionMinor: data.apiVersionMinor,
                        apiVersion: data.apiVersion,
                        paymentMethodDescription: data.paymentMethodData.description,
                        paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                        paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                        paymentMethodType: data.paymentMethodData.type,
                        paymentMethodInfo: data.paymentMethodData.info
                    },
                };
                if (data?.paymentMethodData?.info?.cardFundingSource === 'CREDIT') {
                    paymentMethod.googlePayUS.binType = 'CREDIT';
                }
                const responseEntity = await chargeById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) }, localRecaptchaToken);
                isPayPalGoogle.current = false;
                const orderId = await getMrn(responseEntity.paymentSessionGid, responseEntity.psClientSecret);
                // Step 2: confirm PayPal order
                await window.paypal.Googlepay().confirmOrder({
                    orderId,
                    paymentMethodData: data?.paymentMethodData,
                });
                // Step 3: capture/perform final action
                await action(responseEntity.paymentSessionGid, responseEntity.psClientSecret);
                await chargeByIdSuccessActions(responseEntity);
            }
        } catch (err) {
            console.error('Google Pay Failed', err);
            message.error('GooglePay Transaction Failed');
            chargeByIdFailActions();
        } finally {
            setTransactionModalOpen(false);
        }
    };

    const chargeByGooglePay = async (data) => {
        const paymentMethod = {
            type: "WALLET",
            subType: "GOOGLE_PAY_US",
            googlePayUS: {
                apiVersionMinor: data.apiVersionMinor,
                apiVersion: data.apiVersion,
                paymentMethodDescription: data.paymentMethodData.description,
                paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                paymentMethodType: data.paymentMethodData.type,
                paymentMethodInfo: data.paymentMethodData.info
            },
        };
        if (data?.paymentMethodData?.info?.cardFundingSource === 'CREDIT') {
            paymentMethod.googlePayUS.binType = 'CREDIT';
        }
        setRecaptchaPaymentType('cardPointGooglePay');
        await chargeById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) }, cardPointGooglePayToken);
    };


    const chargeByApple = async (paymentData, recaptchaToken = null) => {
      const {
        deviceData,
        // amount,
        // customerName,
        // customerEmail,
        // customerPhone,
        countryCode,
        stateCode,
        street,
        postalCode,
        city,
        cardNetwork,
        cardType,
        cardLast4,
      } = paymentData;
      const billingAddress = {
          city: city,
          countryCode: countryCode,
          state: stateCode,
          street: street
        };
      // FIXED: Added missing Recaptcha setter found in Implementation 2
      setRecaptchaPaymentType('paypalApplePay');

      const paymentMethod = {
        applePayUS: {
          deviceData: deviceData,
          cardBrand: cardNetwork,
          cardFundingType: cardType,
          applePayDynamicLast4: cardLast4,
          cardLast4: cardLast4,
          binType: payment?.account?.surchargeType !== 'NONE' && payment?.surchargeEnabled ? 'CREDIT' : null,
        },
        type: "WALLET",
        subType: "APPLE_PAY_US",
        postalCode: postalCode,
        paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
      }

      let customer = {
        email: payment?.customer?.email,
        name: payment?.customer?.name,
        phoneNumber: payment?.customer?.phoneNumber,
      }

      const value = await getPayPalAccountInfo(payment?.account?.gid);
      if (value) {
          isPayPalApple.current = true;
      }
      if (paymentData?.token?.paymentMethod?.type === 'credit') {
            paymentMethod.applePayUS.binType = 'CREDIT';
        }

        if (paymentData?.paymentMethod?.type === 'credit') {
            paymentMethod.applePayUS.binType = 'CREDIT';
        }

        if (paymentData?.cardType === 'credit') {
            paymentMethod.applePayUS.binType = 'CREDIT';
        }

      const responseEntity = await chargeById({
        paymentMethod: paymentMethod,
        customerGid: getCustomerGidFromPayment(payment),
        customer: customer,
      }, recaptchaToken);

      isPayPalApple.current = false;
      return responseEntity;
    }

    const chargeByCardpointeApplePay = async (paymentData) => {
        const {
            deviceData,
            // amount,
            customerName,
            customerEmail,
            customerPhone,
            countryCode,
            stateCode,
            street,
            postalCode,
            city,
            cardNetwork,
            cardType,
            cardLast4,
        } = paymentData;
        
        const billingAddress = {
            city: city,
            countryCode: countryCode,
            state: stateCode,
            street: street
        };

        const paymentMethod = {
            applePayUS: {
                deviceData: deviceData,
                cardBrand: cardNetwork,
                cardFundingType: cardType,
                applePayDynamicLast4: cardLast4,
                cardLast4: cardLast4,
                binType: payment?.account?.surchargeType !== 'NONE' && payment?.surchargeEnabled ? 'CREDIT' : null,
            },
            type: "WALLET",
            subType: "APPLE_PAY_US",
            postalCode: postalCode,
            paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
        }

        let customer = {
            email: customerEmail,
            name: customerName,
            phoneNumber: customerPhone,
        }
        if (paymentData?.token?.paymentMethod?.type === 'credit') {
            paymentMethod.applePayUS.binType = 'CREDIT';
        }

        if (paymentData?.paymentMethod?.type === 'credit') {
            paymentMethod.applePayUS.binType = 'CREDIT';
        }

        if (paymentData?.cardType === 'credit') {
            paymentMethod.applePayUS.binType = 'CREDIT';
        }

        await chargeById({
            paymentMethod: paymentMethod,
            customerGid: getCustomerGidFromPayment(payment),
            customer: customer,
        }, null);
    };

    const chargeByApplePay = async (stripePaymentMethod, recaptchaToken = null) => {
        // const meta = stripePaymentMethod;
        const paymentMethod = {
            applePayUS: {
                stripePaymentMethodId: stripePaymentMethod.id,
                cardBrand: stripePaymentMethod.card.brand,
                cardExpMonth: stripePaymentMethod.card.exp_month,
                cardExpYear: stripePaymentMethod.card.exp_year,
                cardFundingType: stripePaymentMethod.card.funding,
                applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
                cardLast4: stripePaymentMethod.card.last4,
                billingAddress: {
                    street: stripePaymentMethod.billing_details.address.line1,
                    city: stripePaymentMethod.billing_details.address.city,
                    state: stripePaymentMethod.billing_details.address.state,
                    postalCode: stripePaymentMethod.billing_details.address.postal_code,
                    countryCode: stripePaymentMethod.billing_details.address.country
                },
                name: payment?.customer?.name ? payment?.customer?.name : stripePaymentMethod.name,
                email: payment?.customer?.email ? payment?.customer?.email : stripePaymentMethod.email,
                phone: payment?.customer?.phoneNumber ? payment?.customer?.phoneNumber : stripePaymentMethod.phone
            },
            customerGid: getCustomerGidFromPayment(payment),
            type: "WALLET",
            subType: "APPLE_PAY_US",
            rawData: {
                stripePaymentMethodId: stripePaymentMethod.id,
                cardBrand: stripePaymentMethod.card.brand,
                cardExpMonth: stripePaymentMethod.card.exp_month,
                cardExpYear: stripePaymentMethod.card.exp_year,
                cardFundingType: stripePaymentMethod.card.funding,
                applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
                cardLast4: stripePaymentMethod.card.last4,
                billingAddress: {
                    street: stripePaymentMethod.billing_details.address.line1,
                    city: stripePaymentMethod.billing_details.address.city,
                    state: stripePaymentMethod.billing_details.address.state,
                    postalCode: stripePaymentMethod.billing_details.address.postal_code,
                    countryCode: stripePaymentMethod.billing_details.address.country
                },
                name: payment?.customer?.name ? payment?.customer?.name : stripePaymentMethod.name,
                email: payment?.customer?.email ? payment?.customer?.email : stripePaymentMethod.email,
                phone: payment?.customer?.phoneNumber ? payment?.customer?.phoneNumber : stripePaymentMethod.phone
            }
        }
        const value = await getPayPalAccountInfo(payment?.account?.gid);
        if (value) {
             isPayPalApple.current = true;
        }
        if (stripePaymentMethod?.token?.paymentMethod?.type === 'credit') {
            paymentMethod.applePayUS.binType = 'CREDIT';
        }

        if (stripePaymentMethod?.paymentMethod?.type === 'credit') {
            paymentMethod.applePayUS.binType = 'CREDIT';
        }
        const responseEntity = await chargeById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) }, recaptchaToken);
        isPayPalApple.current = false;
        return responseEntity;
    };

    const confirmZellPayment = async (zellCode) => {
        const params = {
            acsData: {
                amount: payment?.amount,
                zelleConfirmation: zellPaymentSession.slice(-6),
                zelleName: zellCode
            }
        }
        setTransactionModalOpen(true);
        try {
            const { data: { entity } } = await API2.post(`payment-session/${zellPaymentSession}/action`, params,
                {
                    headers: {
                        'ps-client-secret': zellSecret,
                        'Content-Type': 'application/json',
                    }
                });
                setTransactionModalOpen(false);
                if (entity?.status === 'SUCCEEDED') {
                    setOpen(true);
                    setTimeout(() => {
                      window.location = SWIREPAY_URL;
                    }, 10000)
                } else if (entity?.status !== 'SUCCEEDED') {
                    setOpen1(true);
                    setTimeout(() => {
                      window.location = SWIREPAY_URL;
                    }, 10000)
                }
        } catch (reason) {
            console.error(reason);
        }
    }

    const chargeByZellPay = async (data, recaptchaToken = null) => {
        const paymentMethod = {
            zelle: {},
            customerGid: getCustomerGidFromPayment(payment),
            type: 'WALLET',
            subType: 'ZELLE',
        };
        const payInfo = {
            paymentMethod: paymentMethod,
            customerGid: getCustomerGidFromPayment(payment)
        }
        setTransactionModalOpen(true);
        try {
            const values = await getServerEncription(recaptchaToken);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    const encriptedData = encryptData(JSON.stringify(payInfo), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    }
                    if (encriptedData?.keyId) {
                        const value = await addChargeById(paymentLinkId, payload);
                        if (value?.paymentSessionGid) {
                            setZellPaymentSession(value?.paymentSessionGid);
                            setZellSecret(value?.psClientSecret)
                            setTransactionModalOpen(false);    
                        }
                    }
                }
            }

        } catch (reason) {
            if (reason?.status === 429) {
              setSavedPaymentDetails(payInfo);
              setRecaptchaPaymentType('zelle');
              setRecaptchaModalVisible(true);
              setTransactionModalOpen(false);
            //   throw new Error('Recatpcha Required');
            }
            error(reason);
        }
    };

    const onApprove = async (data) => {
        try {
            await confirmWalletOrderInfo(orderDatas?.paymentSessionGid, orderDatas?.psClientSecret);
            setTransactionSuccessModalOpen(true);
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    const createOrder = async (paypalData, actions) => {
        try {
            const userAgent = {
                acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
                ip: ipAddress,
                language: window.navigator.language,
                colorDepth: window.screen.colorDepth,
                screenHeight: window.screen.height,
                screenWidth: window.screen.width,
                timeZone: new Date().getTimezoneOffset(),
                browserUserAgent: window.navigator.userAgent
            };
            const customer = {
                name: payment?.customer?.name ? payment?.customer?.name : null,
                email: payment?.customer?.email ? payment?.customer?.email : null,
                phone: payment?.customer?.phoneNumber ? payment?.customer?.phoneNumber : null,
            };
            const values = await getServerEncription(commonRecaptchaToken?.current ?? null);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    let data = {};
                    if (paypalData?.paymentSource === 'paypal') {
                        data = {
                            userAgent: userAgent,
                            customer: customer,
                            customerGid: getCustomerGidFromPayment(payment),
                            shouldWhatsAppNotify: false,
                            paymentMethod: {
                                payPalWallet: {
                                    rawData: {
                                        experience_context: {
                                            payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                                            landing_page: "LOGIN",
                                            return_url: SWIREPAY_URL,
                                            cancel_url: SWIREPAY_URL,
                                        }
                                    }
                                },
                                type: "WALLET",
                                subType: "PAYPAL_WALLET"
                            }
                        }
                    } else if (paypalData?.paymentSource === 'venmo') {
                        data = {
                            userAgent: userAgent,
                            customer: customer,
                            customerGid: getCustomerGidFromPayment(payment),
                            shouldWhatsAppNotify: false,
                            paymentMethod: {
                                venmo: {
                                    rawData: {
                                        experience_context: {
                                            payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                                            landing_page: "LOGIN",
                                            return_url: SWIREPAY_URL,
                                            cancel_url: SWIREPAY_URL,
                                        }
                                    }
                                },
                                type: "WALLET",
                                subType: "VENMO"
                            }
                        }
                    }
                    const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    }
                    if (encriptedData?.keyId) {
                        const value = await addChargeById(paymentLinkId, payload);
                        commonRecaptchaToken.current = null;
                        if (value?.paymentSessionGid) {
                            setOrderData(value)
                            const orderData = await getWalletOrderInfo(value?.paymentSessionGid, value?.psClientSecret);
                            if (!orderData.id) {
                                const errorDetail = orderData.details[0];
                                const errorMessage = errorDetail
                                    ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                                    : "Unexpected error occurred, please try again.";

                                throw new Error(errorMessage);
                            }
                            return orderData?.id;
                        }
                    }
                }
            }
        } catch (error) {
            if (error?.status === 429) {
                setSavedPaymentDetails(paypalData);
                setRecaptchaPaymentType('payPalButton');
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                throw new Error('Recatpcha Required');
            }
            console.error(error);
            throw error || new Error('Unexpected error occurred, please try again.');
        }
    };

  const chargeBySavedPaymentMethods = async (data) => {
    await chargeById({ paymentMethod: data });
  };

  const googlePaySplitUp = {
    spObjectType: "PAYMENT_LINK",
    spObjectGid: payment?.gid,
    paymentType: "WALLET",
    subType: "GOOGLE_PAY_US",
    binType: "CREDIT"
  };

  const applePaySplitUp = {
    spObjectType: "PAYMENT_LINK",
    spObjectGid: payment?.gid,
    paymentType: "WALLET",
    subType: "APPLE_PAY_US",
    binType: "CREDIT"
  };

    const uniquePaymentTypes = paymentTypeOrder ? paymentTypeOrder.map((res) => res ? res.category : null) : supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';
    if (uniquePaymentTypes.includes('WALLET')) {
        if (swirepayUS) {
            uniquePaymentTypes.push('SWIREPAY_US');
        }
        if (!googlePayUs) {
            const index = uniquePaymentTypes.indexOf('WALLET');
            if (index > -1) {
                uniquePaymentTypes.splice(index, 1);  // Removes the 'WALLET' from the array
            }
        }
    }
    const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
        let children;
        let id;

        if (name === TabNames.ACH_LEGACY) {
            children = <AchPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment}
                customerDisabled={false}
                headerText={accountGid.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
                showWhatsAppNotify={false}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                netAmount={net}
                serviceFeeAmount={feeService}
                totalPayableAmount={totalPayable}
                serviceFeeEnabled={serviceFeeEnabled}
                surcharge={surcharge}
                surchargeEnabled={payment?.surchargeEnabled}
                surchargeType={payment?.account?.surchargeType}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={paymentLinkId}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
                key="ACH_LEGACY"
            />
            id = name;
        } else if (name === TabNames.CARD) {
            children = <CardPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment}
                headerText={"Pay With Card"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                tabName={tabName}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                customerValidation={true}
                requiredPhone={true}
                showWhatsAppNotify={false}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                ApplePayment={applePayment}
                payment={payment}
                payments={payment}
                netAmount={net}
                serviceFeeAmount={feeService}
                totalPayableAmount={totalPayable}
                serviceFeeEnabled={serviceFeeEnabled}
                amount={net}
                totalPayable={totalPayable}
                tax={tax}
                tip={tip}
                discount={discount}
                subTotal={subTotal}
                serviceFeeVal={serviceFeeVal}
                serviceFee={serviceFeeVal}
                surcharge={surcharge}
                surchargeEnabled={payment?.surchargeEnabled}
                surchargeType={payment?.account?.surchargeType}
                updateSurcharge={updateSurcharge}
                getCardNum={getCardNum}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                chargeByApplePay={chargeByApplePay}
                chargeByApple={chargeByApple}
                surchareNotification={payment?.surchargeEnabled}
            />
            id = name;
        } else if (name === TabNames.UPI) {
            children = <UpiPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByUpi}
                preFillCustomer={payment}
                headerText={"Pay With UPI"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                showMobileViewUpi={true}
                hideQr={false}
                showWhatsAppNotify={false}
                getPaymentById={getPaymentById}
                supportedPaymentTypes={payment && payment.account && payment.account.supportedPaymentTypes}
                upiUrl={`${BASE_URLS.PAYMENT_LINK}/${paymentLinkId}`}
                netAmount={net}
                serviceFeeAmount={feeService}
                totalPayableAmount={totalPayable}
                serviceFeeEnabled={serviceFeeEnabled}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkUpiGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkUpiGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
                onReturnFromUpiApp={onReturnFromUpiApp}
                onChargeByUpiIndent={chargeByUpiIndent}
                acquirer={payment?.account?.acquirer}
            />
            id = name;
        } else if (name === TabNames.ACH) {
            children = <BankPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerDisabled={false}
                submit={chargeByBank}
                preFillCustomer={payment}
                headerText={"Pay With Bank Transfer"}
                buttonText={submitBtnText}
                showWhatsAppNotify={false}
                paymentLinkId={paymentLinkId}
                iavUrl={`${BASE_URLS.PAYMENT_LINK}/${paymentLinkId}`}
                customerValidation={true}
                cancelButtonText={"Decline"}
                requiredPhone={false}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
            />
        } else if (name === TabNames.NET_BANKING) {
            children = <NetBanking
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByNetBanking}
                preFillCustomer={payment}
                showWhatsAppNotify={false}
                headerText={"PAY WITH NET BANKING"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                banksList={banksList}
                bankTypes={bankTypes}
                isTest={isTest}
                netAmount={net}
                serviceFeeAmount={feeService}
                totalPayableAmount={totalPayable}
                serviceFeeEnabled={serviceFeeEnabled}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
            id = name;
        } else if (name === TabNames.CHALLAN) {
            children = <ChallanPayment
                showCancelBtn={payment && payment.canDecline}
                hideCustomer={true}
                showBillDetails={true}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={generateChallan}
                preFillCustomer={payment}
                checkoutPageId={paymentLinkId}
                headerText={"Pay With Challan"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}


                prefix={payment && payment.currency && payment.currency.prefix}
                billAmount={`${currencyFormatter(AmountDivideByHundred(payment && payment.amount), payment && payment.currency && payment.currency.name)}`}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}

                userType={userType}
                payments={payment && payment}
                payment={payment}
                getPaymentCharges={getPaymentCharges}
                convenience={convenience}
                gst={gst}
                totalAmount={totalAmount}
            />
            id = name;
        } else if (name === TabNames.GOOGLE_PAY_US) {
            children = <>
                {
                    payPalClientAuth ? (
                        <PayPalGooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            chargeByGooglePay={chargeByPaypalGooglePay}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                            accountGid={payment?.account?.gid}
                            setTransactionModalOpen={setTransactionModalOpen}
                            splitUpPayload={googlePaySplitUp}
                        />
                    ) : (
                        <GooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            chargeByGooglePay={chargeByGooglePay}
                            gpaySecretValues={gpaySecretValues}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                            splitUpPayload={googlePaySplitUp}
                        />
                    )
                }
            </>
            id = name;
        } else if (name === TabNames.WALLET) {
            children = <>
                {
                    payPalClientAuth ? (
                        <PayPalGooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            chargeByGooglePay={chargeByPaypalGooglePay}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                            accountGid={payment?.account?.gid}
                            setTransactionModalOpen={setTransactionModalOpen}
                            splitUpPayload={googlePaySplitUp}
                        />
                    ) : (
                        <GooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            chargeByGooglePay={chargeByGooglePay}
                            gpaySecretValues={gpaySecretValues}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                            splitUpPayload={googlePaySplitUp}
                        />
                    )
                }
            </>
            id = name;
        } else if (name === TabNames.SWIREPAY_US) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeBySwirepayUS}
                preFillCustomer={payment}
                customerDisabled={true}
                headerText={null}
                buttonText={submitBtnText}
                hideQr={false}
                getPaymentById={getQrPaymentById}
                showWhatsAppNotify={false}
                upiUrl={`${BASE_URLS.PAYMENT_LINK}/${paymentLinkId}`}
                customerValidation={true}
                cancelButtonText={"Decline"}
                netAmount={net}
                serviceFeeAmount={feeService}
                totalPayableAmount={totalPayable}
                serviceFeeEnabled={serviceFeeEnabled}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                swirepayUS={swirepayUS}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkInstantPaymentGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkInstantPaymentGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
            />
            id = name;
        } else if (name === TabNames.INSTANT_PAYMENT) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByInstantPay}
                preFillCustomer={payment}
                customerDisabled={true}
                headerText={null}
                buttonText={submitBtnText}
                hideQr={false}
                getPaymentById={getQrPaymentById}
                showWhatsAppNotify={false}
                upiUrl={`${BASE_URLS.PAYMENT_LINK}/${paymentLinkId}`}
                customerValidation={true}
                cancelButtonText={"Decline"}
                netAmount={net}
                serviceFeeAmount={feeService}
                totalPayableAmount={totalPayable}
                serviceFeeEnabled={serviceFeeEnabled}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkInstantPaymentGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkInstantPaymentGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
            />
            id = name;
        } else if (name === TabNames.ZIP_ACH) {
            children = <ZipAchPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByZipAch}
                preFillCustomer={payment}
                customerDisabled={false}
                headerText={null}
                showWhatsAppNotify={false}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                netAmount={net}
                serviceFeeAmount={feeService}
                totalPayableAmount={totalPayable}
                serviceFeeEnabled={serviceFeeEnabled}
                surcharge={surcharge}
                surchargeEnabled={payment?.surchargeEnabled}
                surchargeType={payment?.account?.surchargeType}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                paymentLinkId={paymentLinkId}
                accountGid={payment?.account?.gid}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
                key="ZIP_ACH"
            />
            id = name;
        } else if (name === TabNames.RAPID_ACH) {
            children = <RapidAchPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByZipAch}
                preFillCustomer={payment}
                customerDisabled={false}
                headerText={null}
                showWhatsAppNotify={false}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                netAmount={net}
                serviceFeeAmount={feeService}
                totalPayableAmount={totalPayable}
                serviceFeeEnabled={serviceFeeEnabled}
                surcharge={surcharge}
                surchargeEnabled={payment?.surchargeEnabled}
                surchargeType={payment?.account?.surchargeType}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                paymentLinkId={paymentLinkId}
                accountGid={payment?.account?.gid}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
                key="RAPID_ACH"
            />
            id = name;
        } else if (name === TabNames.X_ACH) {
            children = <XAchPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment}
                customerDisabled={false}
                headerText={null}
                showWhatsAppNotify={false}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                netAmount={net}
                serviceFeeAmount={feeService}
                totalPayableAmount={totalPayable}
                serviceFeeEnabled={serviceFeeEnabled}
                surcharge={surcharge}
                surchargeEnabled={payment?.surchargeEnabled}
                surchargeType={payment?.account?.surchargeType}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                paymentLinkId={paymentLinkId}
                accountGid={payment?.account?.gid}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
                key="X_ACH"
            />
            id = name;
        } else if (name === TabNames.INSTANT_ACH) {
            children = <InstantAch
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByZipAch}
                preFillCustomer={payment}
                customerDisabled={false}
                headerText={null}
                showWhatsAppNotify={false}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                netAmount={net}
                serviceFeeAmount={feeService}
                totalPayableAmount={totalPayable}
                serviceFeeEnabled={serviceFeeEnabled}
                surcharge={surcharge}
                surchargeEnabled={payment?.surchargeEnabled}
                surchargeType={payment?.account?.surchargeType}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                paymentLinkId={paymentLinkId}
                accountGid={payment?.account?.gid}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
                key="INSTANT_ACH"
            />
            id = name;
        } else if (name === TabNames.SWIFT_ACH) {
            children = <SwiftAch
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByZipAch}
                preFillCustomer={payment}
                customerDisabled={false}
                headerText={null}
                showWhatsAppNotify={false}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                netAmount={net}
                serviceFeeAmount={feeService}
                totalPayableAmount={totalPayable}
                serviceFeeEnabled={serviceFeeEnabled}
                surcharge={surcharge}
                surchargeEnabled={payment?.surchargeEnabled}
                surchargeType={payment?.account?.surchargeType}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                paymentLinkId={paymentLinkId}
                accountGid={payment?.account?.gid}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
                key="SWIFT_ACH"
            />
            id = name;
        } else {
            children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
        }
        panel.push({ children, id });
        return panel;
    }, []) : [
        {
            children: <CardPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment}
                headerText={"Pay With Card"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                customerValidation={true}
                showWhatsAppNotify={false}
                requiredPhone={true}
                tabName={tabName}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                ApplePayment={applePayment}
                payment={payment}
                netAmount={net}
                serviceFeeAmount={feeService}
                totalPayableAmount={totalPayable}
                serviceFeeEnabled={serviceFeeEnabled}
                serviceFee={serviceFeeVal}
                amount={net}
                totalPayable={totalPayable}
                tax={tax}
                tip={tip}
                discount={discount}
                subTotal={subTotal}
                serviceFeeVal={serviceFeeVal}
                surcharge={surcharge}
                surchargeEnabled={payment?.surchargeEnabled}
                surchargeType={payment?.account?.surchargeType}
                updateSurcharge={updateSurcharge}
                getCardNum={getCardNum}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                chargeByApplePay={chargeByApplePay}
                surchareNotification={payment?.surchargeEnabled}
                payments={payment}
            />,
            id: 'CARD'
        }
    ];

    const tabPanelsApple =

    { //children :  <Apple amount={AmountDivideByHundred(payment && payment.amount)} chargeByApple={chargeByApple} payment={payment}/>
        children: <>
                {
                    payPalClientAuth ? (
                        <ApplePayButton
                            recaptchaToken={paypalApplePayRecaptcha}
                            amount={payment && payment.amount}
                            chargeByApple={chargeByApple}
                            payment={payment}
                            accountGid={payment?.account?.gid}
                            successCallback={chargeByIdSuccessActions}
                            failCallback={chargeByIdFailActions}
                            splitUpPayload={applePaySplitUp}
                            surchargeEnabled={payment?.account?.surchargeType !== 'NONE' && payment?.surchargeEnabled}
                        />
                    ) : (
                        <>
                        {
                            applePayment && isApplePay ? (
                                <Apple
                                    amount={payment && payment.amount}
                                    chargeByApple={chargeByCardpointeApplePay}
                                    payment={payment}
                                    splitUpPayload={applePaySplitUp}
                                    surchargeEnabled={payment?.account?.surchargeType !== 'NONE' && payment?.surchargeEnabled}
                                /> ) : null
                        }
                        </>
                    )
                }
            </>,
        id: applePayment && isApplePay ? 'APPLE_PAY_US' : null
    };

    tabPanels.push(tabPanelsApple);

  if (payment?.account?.country?.alpha2 === 'US') {
    tabPanels.push({
    //   children: <SavedPaymentMethods
    //               buttonText={submitBtnText}
    //               submit={chargeBySavedPaymentMethods}
    //               supportedPaymentTypes={uniquePaymentTypes}
    //               surchareNotification={payment?.surchargeEnabled}
    //               accountSupportedPaymentTypes={payment?.account?.supportedPaymentTypes}
    //               updateSurcharge={updateSurcharge}
    //             />,
    children: <SavedPaymentMethods
            buttonText={submitBtnText}
            submit={chargeBySavedPaymentMethods}
            supportedPaymentTypes={uniquePaymentTypes}
            surchareNotification={payment?.surchargeEnabled}
            accountSupportedPaymentTypes={payment?.account?.supportedPaymentTypes}
            updateSurcharge={updateSurcharge}
            surchargeEnabled={payment?.surchargeEnabled}
            surchargeType={payment?.account?.surchargeType}
            tip={tip}
            surcharge={surcharge}
            serviceFee={serviceFeeVal}
            serviceFeeRate={undefined}
            serviceFeeRateVal={undefined}
            amount={net}
            serviceFeeVal={serviceFeeVal}
            discount={discount}
            subTotal={subTotal}
            totalPayable={totalPayable}
            prefix={payment?.account?.currency?.prefix}
            tax={tax}
        />,
      id: 'SAVED_PAYMENT_METHODS'
    });
    tabPanels.push({
      children: <>
        <ZelleCheckout
          createZellPayment={chargeByZellPay}
          zellPaymentSession={zellPaymentSession}
          confirmZellPayment={confirmZellPayment}
        />
        <VerifyZellPaymentModal
            open={open}
            onClose={() => setOpen(false)}
        />
        <ZellConfirmationModal open={open1} />
      </>,
      id: 'ZELLE'
    });
    payment?.account?.supportedPaymentTypes.includes("ZELLE") && Array.isArray(uniquePaymentTypes) && uniquePaymentTypes.push('ZELLE');
  }

  if (payPalClientAuth && payPalClientId && payment?.paymentMethodType?.includes('WALLET') && (payment?.account?.supportedPaymentTypes?.includes('PAYPAL_WALLET') || payment?.account?.supportedPaymentTypes?.includes('VENMO'))) {
    tabPanels.push({
      children: <div style={{ width: '200px'}} >
      <PayPalCheckout
        styles={{ shape: "rect", layout: "vertical" }}
        createOrder={createOrder}
        onApprove={onApprove}
        payPalClientId={payPalClientId}
        currency={payment?.account?.currency?.name || 'USD'}
        country={payment?.account?.country?.alpha2 || 'US'}
        accountSupportedPaymentTypes={payment?.account?.supportedPaymentTypes}
      />
      </div>,
      id: 'PAYPAL_METHOD',
    });
    uniquePaymentTypes.push('PAYPAL_METHOD');
  }

  useEffect(() => {
      setTabName(uniquePaymentTypes && uniquePaymentTypes[selectedTab]);
  }, [selectedTab, uniquePaymentTypes]);
  const agregatorName = payment && payment.account && payment.account.aggregatorName;

  return (
      <BaseSplitPage
          errorHeader={null}
          errorMsg={errorMessage}
          left={
              <>
                  <FlexContainer
                      flexDirection="column"
                      position="relative"
                      display="block"
                      height="100%"
                  >
                      <div>
                          {
                              (payment && payment.account && payment.account.largeLogo) && (
                                  <img src={payment.account.largeLogo} style={{ width: "125px" }} alt="" />
                              )
                          }
                          <H1Text>
                              Payment Checkout
                          </H1Text>
                          <H2Text>
                              Payment For
                          </H2Text>
                          <DescriptionText>
                              {payment && payment.description}
                          </DescriptionText>
                          <H2Text>
                              Amount Payable
                          </H2Text>
                          <DescriptionText fontSize="24px">
                              {totalPayable
                                  ? `${currencyFormatter(AmountDivideByHundred(totalPayable), payment.currency && payment.currency.name)}`
                                  : payment && payment?.tip
                                      ? `${currencyFormatter(AmountDivideByHundred(payment.amount + payment.tip), payment.currency && payment.currency.name)}`
                                      : payment
                                          ? `${currencyFormatter(AmountDivideByHundred(payment.amount), payment.currency && payment.currency.name)}`
                                          : null
                              }
                          </DescriptionText>
                      </div>
                      <div style={{ position: "sticky", top: "85%" }}>
                          <Support email={payment && payment.support && payment.support.email}
                              phone={payment && payment.support && payment.support.phone}
                              partnerImageUrl={partnerImageUrl}
                              bankImageUrl={bankImageUrl}
                              whiteLabel={payment && payment.account && payment.account.whiteLabel}
                          />
                          {agregatorName === 'EPAYMENTS' ?
                              <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }} >
                                  <a href="https://www.swirepay.com" target="_blank" >
                                      <img src={EPaymentImg} alt="" />
                                  </a>
                              </div>
                              :
                              agregatorName === 'OMEGAITR' ?
                                  <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }} >
                                      <a href="https://www.swirepay.com" target="_blank" >
                                          <img src={OMEGAITRlogo} alt="" />
                                      </a>
                                  </div>
                                  :
                                  ''
                          }
                      </div>
                  </FlexContainer>
              </>
          } right={
              <>
                  <Header
                      payment={payment}
                      totalPayable={totalPayable}
                      bankImageUrl={bankImageUrl}
                      cancelUrlLink={null}
                  />
                  {payment?.account?.country?.alpha2 === 'US' ? (
                    <PaymentExpandableRowsV2
                        id={paymentLinkId}
                        tabs={uniquePaymentTypes}
                        tabPanels={tabPanels}
                        upiDown={false}
                        applePayment={applePayment}
                        isApplePay={isApplePay}
                        supportedPaymentTypes={payment?.account?.supportedPaymentTypes}
                        account={payment?.account}
                        getCurrentTab={getCurrentTab}
                    />) : (
                        <PaymentExpandableRows
                        id={paymentLinkId}
                        tabs={uniquePaymentTypes}
                        tabPanels={tabPanels}
                        upiDown={false}
                        applePayment={applePayment}
                        isApplePay={isApplePay}
                        accountGid={payment?.account?.gid}
                        amount={payment?.amount}
                        offerRequired={payment?.account?.enableAcquirerOffer || false}
                        getCurrentTab={getCurrentTab}
                    />
                  )}
                  <RecaptchaModal
                      visible={recaptchaModalVisible}
                      onVerified={onGlobalCaptchaVerified}
                  />
                  <SmallScreenFooter
                      partnerImageUrl={partnerImageUrl}
                      bankImageUrl={bankImageUrl}
                      whiteLabel={payment && payment.account && payment.account.whiteLabel}
                  />
                  <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
                  <SuccessModal isOpen={isTransactionSuccessModalOpen} processing={processStatus} manualPlaidPayment={manualPlaidPayment} />
                  <AlertModal
                      showIcon={alertConfig.showIcon}
                      isOpen={alertConfig.isOpen}
                      hideBtn={alertConfig.hideBtn}
                      cancel={alertConfig.cancel}
                      header={alertConfig.header}
                      body={alertConfig.body}
                      submitBtnText={alertConfig.submitBtnText}
                      cancelBtnText={alertConfig.cancelBtnText}
                      showCancelBtn={alertConfig.showCancelBtn}
                      showSubmitBtn={alertConfig.showSubmitBtn} submit={alertConfig.submit} icon={alertConfig.icon} />
                  <Spinner isOpen={isShowSpinner} />
              </>
          } />
  )
};

export default PaymentLink;